module.exports = "/_next/static/images/scam_nft_fff-140ac437d3d02da6459385b64e863a65.png";